import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../../api";
import functions from "../../../../functions";

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            Nombre: "",
            postVariables: ["Nombre"],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['EDIT', 'DETAIL']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            Nombre: "",
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }
;
    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                Nombre: data.Nombre,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Color",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Color ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Color",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.gestion.articulos.colores : null)}
                submitUrl={(vars.submitType ? api.gestion.articulos.colores : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}
                className="modal-condicion-pago"

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveReloadButton={action == "CREATE"}
                saveReloadButtonLabel="Guardar y Nuevo"
                closeButton={true}
            >
                <ParadigmaLabeledInput
                    disabled={vars.disabled}
                    md={[2, 10]}
                    label={"Nombre"}
                    value={this.state.Nombre}
                    onChange={(e) => this.onChangeField('Nombre', e.target.value)}
                    error={() => this.getError('Nombre')}
                />
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Colores/Modal.js